module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "is-full column"
  }, [_c('h1', [_vm._v(_vm._s(this.name))]), _vm._v(" "), _c('h2', [_vm._v("Design by: " + _vm._s(this.designer))]), _vm._v(" "), _c('div', {
    staticClass: "gallery-item",
    attrs: {
      "data-n": this.n
    }
  }, [(_vm.mobileurl !== '') ? _c('div', {
    staticClass: "phone-container"
  }, [_c('div', {
    staticClass: "phone"
  }, [_c('div', {
    staticClass: "phone-inner"
  }, [_c('div', {
    staticClass: "screen"
  }, [_c('lazy-component', {
    attrs: {
      "data-n": this.n + 'p'
    },
    on: {
      "show": _vm.beginAnimation
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mobileurl,
      "alt": this.name + ' Mobile'
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "spinner",
      "scale": "3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('img', {
    staticClass: "phone-img",
    attrs: {
      "src": "static/mobile.png",
      "alt": "Mobile View"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitor-container"
  }, [_c('div', {
    staticClass: "monitor"
  }, [_c('div', {
    staticClass: "monitor-inner"
  }, [_c('div', {
    staticClass: "screen"
  }, [_c('lazy-component', {
    attrs: {
      "data-n": this.n + 'm'
    },
    on: {
      "show": _vm.beginAnimation
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainurl,
      "alt": this.name + ' Site'
    }
  }), _vm._v(" "), _c('icon', {
    attrs: {
      "name": "spinner",
      "scale": "3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('img', {
    staticClass: "monitor-img",
    attrs: {
      "src": "static/desktop.png",
      "alt": "Desktop View"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-670d50f9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Galleryitem.vue
// module id = 112
// module chunks = 2